import React from 'react';

import { LinkBlockItemActive } from '@app/objects/LinkBlockItem';

export const petLossGroupLinkItems: Array<LinkBlockItemActive> = [
	{
		path: '/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
	},
	{
		path: '/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
	},
	{
		path: '/our-services/aftercare',
		name: 'Aftercare',
	},
	{
		path: '/our-services/telehospice',
		name: 'Telehospice',
	},
	{
		path: '/our-services/pet-loss-support',
		name: 'Pet Loss Support',
		active: true,
	},
];

export const petLossSupportGroupsAndResources = (
	<>
		<p>
			Grieving is a deeply personal experience, and no two journeys are the same. Lap of Love offers gentle, guided support to help you find
			comfort, connection, and peace after the loss of your cherished pet.
		</p>
		<p>
			Our professionally certified pet loss coaches lead a range of free and fee-based, virtual sessions including small groups, private
			one-on-one support, and extended courses…all designed to help you heal at your own pace. Explore our support options.
		</p>
		<p>
			<a href="https://petloss.lapoflove.com/" className="btn btn-sm btn-primary" target="_blank" rel="noopener noreferrer">
				Pet Loss Resource Center
			</a>
		</p>
	</>
);
